<script setup lang="ts">
const { data: investigationArticles } = await useInvestigationArticles()

const article = computed(() => (investigationArticles.value ?? []).at(0))
</script>

<template>
  <UPageSection v-if="article" :title="article.title">
    <main class="bg-neutral-50 dark:bg-neutral-800 p-8 border border-neutral-100 dark:border-neutral-700 shadow-md shadow-neutral-200 dark:shadow-neutral-900 rounded-2xl">
      <div class="grid lg:grid-cols-2 gap-8">
        <div>
          <div class="overflow-hidden rounded border border-neutral-300 bg-neutral-100 shadow-md shadow-neutral-200 dark:border-neutral-400 dark:bg-neutral-900 dark:shadow-neutral-900">
            <VideoPreview :url="article.video" :title="article.title" />
          </div>
        </div>
        <div class="flex flex-col">
          <div class="flex-grow flex justify-center items-center text-neutral-800 dark:text-neutral-300 lg:text-xl leading-8">
            {{ article.description }}
          </div>
          <div class="flex justify-end">
            <UButton :to="article.path" class="mt-4" size="xl" color="primary" icon="bx:chevron-right">
              Lees meer
            </UButton>
          </div>
        </div>
      </div>
    </main>
  </UPageSection>
</template>
